import type { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';

/** AuthPath 页面未配置或配置请求失败时使用的默认配置。 */
export const PAGE_CONFIG = {
  name: 'AuthPath',
} as unknown as IPageConfigType;
